import { Slider } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../components/form-item'

export function CampaignNotificationsSection() {
    const { t } = useTranslation()

    return (
        <>
            <FormItem
                name="notificationThreshold"
                label={
                    <span className="whitespace-normal">{t('Only notify me about candidates scoring at least')}</span>
                }
            >
                <Slider
                    marks={{
                        0: '0',
                        50: '50',
                        75: <span className="whitespace-nowrap">🏆 {75}</span>,
                        100: '100',
                    }}
                />
            </FormItem>
        </>
    )
}
